import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from '@panel/commons/lib/Input/InputCheckbox';
import { sendTrackingInfo } from '@panel/commons';
import { getColor } from '@panel/commons/core/themev3';
import SortMenu from './SortMenu';
import { SearchBar, SearchBarLeftSide, SearchBarRightSide } from './styles';
import ActionsArea from './ActionsArea';
import useUrlSearchParams from '../../hooks/useUrlSearchParams';
import { PostingsOperations } from '../../../../ducks/posting';
import { FilterOperations, FilterSelectors } from '../../../../ducks/filter';
import Searchbox from '../../commons/Searchbox';

const Bar = ({
  device,
  postings,
  setBulkActionsModals,
  bulkActionsModals,
  barMessageNumber,
  selectedNumber,
  setFilterDrawer,
  isAssistant,
  userCanEditResponsible
}) => {
  const { t } = useTranslation();
  const [searchCode, setSearchCode] = useState('');
  const dispatch = useDispatch();
  const [checkAll, setCheckAll] = useState(false);
  const { appliedFilters } = useSelector(FilterSelectors.getFiltersState);
  const { setUrlSearch } = useUrlSearchParams();

  useEffect(() => {
    if (postings.length > selectedNumber) {
      setCheckAll(false);
    } else if (postings.length && selectedNumber === postings.length) {
      setCheckAll(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNumber]);

  const handleCheck = useCallback(() => {
    const checked = !checkAll;
    dispatch(PostingsOperations.checkPosting(null, checked));
    setCheckAll(checked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkAll]);

  const handleSubmit = e => {
    setUrlSearch(e.target[0].value, 'searchCode');
    sendTrackingInfo('Panel', 'Mis avisos', 'Buscador de avisos-Buscar');
    dispatch(FilterOperations.update({ searchCode: { id: e.target[0].value, displayName: e.target[0].value } }));
  };

  const handleChange = e => {
    // SE EVITA LA BÚSQUEDA CON CARACTER ";" Y ","
    setSearchCode(e.target.value.replaceAll(/[;,]/g, ''));
  };

  useEffect(() => {
    if (!appliedFilters.searchCode.displayName) setSearchCode('');
  }, [appliedFilters]);

  return (
    <SearchBar data-panel='postingsBar' data-tour-panel='search-and-filter' device={device}>
      <SearchBarLeftSide device={device}>
        {!isAssistant && (
          <div data-panel='postingsBar-checkSelectAll' onClick={handleCheck} className='checkBox-container'>
            <Checkbox
              className='no-margin'
              readOnly
              name='check-all-postings'
              checked={checkAll}
              fillColor={getColor('primary')}
            />
          </div>
        )}
        <ActionsArea
          bulkActionsModals={bulkActionsModals}
          setBulkActionsModals={setBulkActionsModals}
          postings={postings}
          device={device}
          userCanEditResponsible={userCanEditResponsible}
          checkAddedPostings={postings?.filter(item => item.checked)}
        />
        <div data-panel='postingsBar-totalCount' className='quantity-label'>
          {selectedNumber ? t('panel.bar.number.selected.postings') : t('panel.bar.number.found.postings')}
          <b>
            <span>
              {barMessageNumber} {t(barMessageNumber !== 1 ? 'postings' : 'posting')}
            </span>
          </b>
        </div>
      </SearchBarLeftSide>
      <SearchBarRightSide device={device}>
        <div className='search-container'>
          <Searchbox
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            value={searchCode}
            placeholder={t('panel.avisos.filters.searchPlaceholder')}
          />
        </div>
        <SortMenu device={device} />
        {device === 'tablet' && (
          <div onClick={() => setFilterDrawer(true)} className='filter-button-tablet'>
            <div />
          </div>
        )}
      </SearchBarRightSide>
    </SearchBar>
  );
};

export default Bar;
